import React, { useState } from 'react';
import Student from './Student';
import Modal from 'react-modal';
import { useStudentsActions, useStudentsState } from '../../contexts/StudentsContext';

const StudentsContainer = () => {
  const [editMode, setEditMode] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [studentToDelete, setStudentToDelete] = useState('');
  const [searchText, setSearchText] = useState('');
  const gap = 1.5;
  const calculateFlex = (): number => {
    const studentsPerRow = 3;
    return Math.round((100 - gap * (studentsPerRow - 1)) / studentsPerRow);
  };

  const { students } = useStudentsState();
  const { deleteStudent, addEmptyStudent } = useStudentsActions();

  return (
    <div>
      <label
        htmlFor="default-search"
        className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
      >
        Search
      </label>
      <div className="relative mb-4">
        <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
          <svg
            className="w-4 h-4 text-gray-500 dark:text-gray-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 20"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
            />
          </svg>
        </div>
        <input
          type="search"
          id="default-search"
          className="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          placeholder="Search students"
          required
          onChange={(e) => setTimeout(() => setSearchText(e.target.value), 0)}
        />
      </div>
      <div className="flex mb-4">
        <button
          className={`${editMode ? 'bg-indigo-300' : 'bg-indigo-600'} ${editMode ? '' : 'hover:bg-indigo-500'} text-white font-bold py-2 px-4 rounded ml-auto`}
          onClick={() => {
            addEmptyStudent();
            setEditMode(true);
          }}
          disabled={editMode}
        >
          Create Student
        </button>
      </div>
      <div className="flex flex-wrap" style={{ gap: `${gap}%` }}>
        {students
          .filter(({ firstName, lastName, primaryParentPhone, secondaryParentPhone }) => {
            return (
              `${firstName} ${lastName}`.toLowerCase().includes(searchText.toLowerCase()) ||
              primaryParentPhone.includes(searchText.toLowerCase()) ||
              secondaryParentPhone?.includes(searchText.toLowerCase())
            );
          })
          .map(
            (
              {
                firstName,
                lastName,
                primaryParentPhone,
                secondaryParentPhone,
                barcode,
                checkInTime,
                sessionTime,
                sendText,
              },
              i,
            ) => {
              return (
                <Student
                  key={`student-${firstName}-${lastName}`}
                  index={i}
                  firstName={firstName}
                  lastName={lastName}
                  primaryParentPhone={primaryParentPhone}
                  secondaryParentPhone={secondaryParentPhone}
                  sessionTime={sessionTime.toString()}
                  barcode={barcode}
                  sendText={sendText}
                  checkInTime={checkInTime}
                  flex={calculateFlex()}
                  editInProgress={editMode}
                  setEditInProgress={setEditMode}
                  setOpenDeleteModal={(barcode: string) => {
                    if (barcode === '') {
                      setOpenDeleteModal(false);
                    } else {
                      setStudentToDelete(barcode);
                      setOpenDeleteModal(true);
                    }
                  }}
                />
              );
            },
          )}
      </div>
      <Modal
        isOpen={openDeleteModal}
        onRequestClose={() => setOpenDeleteModal(false)}
        contentLabel="Delete Student"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '25%',
            height: '15%',
            borderRadius: '20px',
          },
        }}
        // className="w-[40%] h-[20%] rounded "
      >
        <div className="h-[100%] flex flex-col justify-between">
          <h2>Are you sure you want to delete this student?</h2>
          <div className="flex gap-[50%]">
            <button
              className="flex justify-center rounded-md bg-white px-3 py-1.5 text-sm/6 font-semibold border-gray-400 text-black shadow-xs hover:bg-gray-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-200 border mt-2"
              style={{ flex: '49%' }}
              onClick={() => setOpenDeleteModal(false)}
            >
              No, cancel
            </button>
            <button
              className={`flex justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 mt-2`}
              style={{ flex: '49%' }}
              onClick={async () => {
                await deleteStudent(studentToDelete);
                setOpenDeleteModal(false);
              }}
            >
              Yes, I'm sure
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default StudentsContainer;
